export enum FormRequestType {
	None = 0,
	UserData = 1,
	SearchRequest = 2
}
